<div class="carousel-dialog">
  <div class="dialog-header">
    <button (click)="closeDialog()" aria-label="Close" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (deleteImageCallback) {
    <app-mat-icon-button
      [callback]="onDeleteImage.bind(this)"
      [params]="[]"
      color="warn"
      cssClass="mb-3"
      icon="delete"
      label="Delete this image"></app-mat-icon-button>
  }

  @if (imgUrls.length) {
    <div class="carousel-body">
      <button (click)="previousImage()" aria-label="Vorheriges Bild" class="nav-button" mat-icon-button>
        <mat-icon>chevron_left</mat-icon>
      </button>
      <div class="image-wrapper">
        @if (imgUrls[selectedId]; as imgUrl) {
          <picture>
            <source [srcset]="imgUrl.w350" media="(max-width: 350px)" />
            <source [srcset]="imgUrl.w500" media="(max-width: 500px)" />
            <source [srcset]="imgUrl.w750" media="(max-width: 750px)" />
            <source [srcset]="imgUrl.w1124" media="(max-width: 1124px)" />
            <source [srcset]="imgUrl.w1500" media="(max-width: 1500px)" />
            <img [alt]="imgUrl.title || altName" [src]="imgUrl.full" />
          </picture>
        }
      </div>
      <button (click)="nextImage()" aria-label="Nächstes Bild" class="nav-button" mat-icon-button>
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
    @if (imgUrls[selectedId]; as imgUrl) {
      <p class="caption">{{ imgUrl.title || altName }}</p>
    }
  } @else {
    <p class="caption">{{ noImagesText }}</p>
  }
</div>
